export default __webpack_public_path__ + "static/internation_resellers_hero-432134f7dce0df4a7f622f5e2b0cc64c.png";